import { ActivatedRoute } from "@angular/router";
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter
} from "@angular/core";
import { SecurityInfo, DisplayTime, MfaSettings } from "../account/model";
import { TimeService } from "../time.service";
import { GoogleAuthReturn } from "./model";

@Component({
  moduleId: module.id.toString(),
  selector: "my-security",
  template: require('./security.component.html')
})
export class SecurityComponent implements OnInit {
  constructor(
    private _timeservice: TimeService,
    private route: ActivatedRoute
  ) {}
  @Input()
  security: SecurityInfo;
  @Input()
  mfaSettings: MfaSettings;
  @Input()
  isPartnerUser: false;
  @Input()
  links: string[] = [];
  @ViewChild("GoogleAuth")
  googlAuthWiz: any;
  @Output()
  SetKey: EventEmitter<any> = new EventEmitter();

  sliderConfig: any = {
    behaviour: "drag",
    connect: [true, false],
    start: [0, 4],
    step: 0.083,
    range: {
      min: 0,
      max: 4
    },
    pips: {
      mode: "count",
      density: 12,
      values: 5,
      stepped: true
    }
  };

  ssoError: boolean = true;
  showGoogleAuthWizard: boolean = false;
  private sub: any;

  ngOnInit(): void {
    this.sub = this.route.params.subscribe((params: { [x: string]: string | number; }): void => {
      if (+params["e"] == 1) {
        this.ssoError = false;
      }
    });
    if (this.mfaSettings) {
      this.mfaSettings.EmailDisabled = this.mfaSettings.ForceEmailMfaEnabled;
    }
  }

  MfaOnOffClicked(): void {
    this.mfaSettings.MfaEnabled = this.mfaSettings.MfaStatus == "MfaEnabled";
    this.mfaSettings.MfaHasChange = true;

    this.mfaSettings.MfaHasErrors = this.formHasMfaErrors();
  }

  onMfaEmailChange(change: boolean) {
    this.mfaSettings.EmailChecked = change;
    this.mfaSettings.MfaHasChange = this.formHasChanges();
    
    if (!change) {
      this.mfaSettings.MfaSelectedOptions =
        this.mfaSettings.MfaSelectedOptions - 1;
    } else {
      this.mfaSettings.MfaSelectedOptions =
        this.mfaSettings.MfaSelectedOptions + 1;
    }

    this.mfaSettings.MfaHasErrors = this.formHasMfaErrors();
  }

    formHasChanges(): boolean {
        return (
            this.mfaSettings.EmailCheckedInitial != this.mfaSettings.EmailChecked ||
            this.mfaSettings.PhoneCheckedInitial != this.mfaSettings.PhoneChecked ||
            this.mfaSettings.GoogleAuthCheckedInitial != this.mfaSettings.GoogleAuthChecked ||
            this.security.sliderTimeInitial != this.security.sliderTime
        );
    }

    formHasMfaErrors(): boolean {
        return (
            this.mfaSettings.MfaSelectedOptions < 2 && this.mfaSettings.MfaEnabled
        );
    }

  onMfaPhoneChange(change: boolean) {
    this.mfaSettings.PhoneChecked = change;
    this.mfaSettings.MfaHasChange = this.formHasChanges();
    if (!change) {
      this.mfaSettings.MfaSelectedOptions =
        this.mfaSettings.MfaSelectedOptions - 1;
    } else {
      this.mfaSettings.MfaSelectedOptions =
        this.mfaSettings.MfaSelectedOptions + 1;
    }

    this.mfaSettings.MfaHasErrors = this.formHasMfaErrors();
  }

  onMfaGoogleAuthChange(change: boolean) {
    if (change && this.mfaSettings.GoogleAuthenticatorStatus === 2) {
      this.ReinitalizeWizardComponent();
      this.showGoogleAuthWizard = true;
    } else if (!change && this.mfaSettings.GoogleAuthenticatorStatus === 1) {
      this.mfaSettings.GoogleAuthChecked = change;
    }

    this.mfaSettings.GoogleAuthChecked = change;
    this.mfaSettings.MfaHasChange = this.formHasChanges();
    if (change) {
      this.mfaSettings.MfaSelectedOptions =
        this.mfaSettings.MfaSelectedOptions + 1;
    } else {
      this.mfaSettings.MfaSelectedOptions =
        this.mfaSettings.MfaSelectedOptions - 1;
    }

    this.mfaSettings.MfaHasErrors = this.formHasMfaErrors();
  }

  onSessionTimeoutChange(newSliderTime: number) {
    this.security.displayTime = this._timeservice.getDisplayTime(newSliderTime);
    this.security.sessionTimeout = Math.ceil(
      this._timeservice.convertHoursToMin(newSliderTime)
    );
  }

  onChange(sliderTime: number) {
      if (sliderTime < 0.083) this.security.sliderTime = 0.083;
      this.mfaSettings.MfaHasChange = this.formHasChanges();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ReinitalizeWizardComponent() {
    this.googlAuthWiz.ngOnInit();
  }

  GoogleAuthenticatorClicked() {
    this.showGoogleAuthWizard = true;
  }

  CloseGoogleAuthWizard(e: GoogleAuthReturn) {
    switch (e.Status) {
      case "Success":
        this.mfaSettings.GoogleAuthChecked = true;
        this.SetKey.emit(e.totpKey);
        this.mfaSettings.MfaHasChange = true;
        this.showGoogleAuthWizard = false;
        break;
      case "Close":
        this.mfaSettings.GoogleAuthChecked = false;
        this.showGoogleAuthWizard = false;
        this.SetKey.emit("");
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/security/security.component.ts